import React, { useState } from "react";
// import HomePage from "../components/pages/home/HomePage";
import ProjectsPage from "../components/pages/project/ProjectsPage";
// import PROJECTS from "../utilities/projects";
import "../icons/fontawesome.js";
import LoginPage from "../components/login/Login";
import { DataContext } from "../store/DataContext";

const MainSite = (props) => {
	const [activeProject, setActiveProject] = useState(null);
	return (
		<>
			{!props.login.status || props.login.show ? (
				<LoginPage
					{...props.login}
					clicked={props.toggleLoginPanel}
					submitted={props.changeLoginStatus}
				/>
			) : (
				<>
					{/* <HomePage /> */}
					<ProjectsPage
						// projects={PROJECTS}
						active={activeProject}
						changeActiveProjectHandler={setActiveProject}
					/>
				</>
			)}
		</>
	);
};

export default (props) => (
	<DataContext.Consumer>
		{(mainConsumer) => <MainSite {...mainConsumer} {...props} />}
	</DataContext.Consumer>
);
